import { useEffect, useRef, useState } from 'react'

import { checkRut, formatRut } from '../../../lib/rut'
import { Field, FieldProps, useControlId } from './Field'

const INVALID_RUT = 'Rut Invalido'

export function RutField({
  label,
  error,
  hint,
  labelStyle,
  className,
  style,
  id,
  value,
  onChange,
  ...rest
}: FieldProps & {
  value: string
  onChange: (value: string) => void
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange' | 'id' | 'className' | 'style' | 'type' | 'onBlur'>) {
  const controlId = useControlId(id)
  const inputRef = useRef<HTMLInputElement>(null)
  const [touched, setTouched] = useState(false)
  const isInvalid = value.length > 0 && !checkRut(value)

  // The browser then refuses to submit the form, the same way it enforces `required`.
  useEffect(() => {
    inputRef.current?.setCustomValidity(isInvalid ? INVALID_RUT : '')
  }, [isInvalid])

  const normalizeOnBlur = (raw: string) => {
    setTouched(true)
    if (checkRut(raw)) {
      onChange(formatRut(raw))
    }
  }

  return (
    <Field
      label={label}
      error={error ?? (touched && isInvalid ? INVALID_RUT : undefined)}
      hint={hint}
      labelStyle={labelStyle}
      className={className}
      style={style}
      controlId={controlId}
    >
      <input
        ref={inputRef}
        id={controlId}
        type="text"
        className="form-control rut"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        onBlur={(event) => normalizeOnBlur(event.target.value)}
        onInvalid={() => setTouched(true)}
        {...rest}
      />
    </Field>
  )
}
